<div
  class="ps-fields-related-btn-integration-container"
  [formGroup]="formGroup">
  <div
    fxLayout="column"
    *ngFor="let control of controlForm.controls; let i = index;"
    formArrayName="fields_related">
    <div
      class="ps-fields-related-btn-integration-row"
      fxLayoutAlign="start center"
      fxLayout="row"
      [formGroupName]="i">
      <div
        [style.margin-bottom.em]="1"
        fxFlex="37">
        <p class="ps-fields-related-btn-integration-name">
          {{control.get('title').value}}
          <span style="color: red;">{{control.get('is_required').value === 1 ? ' *' : ''}}</span>
        </p>
        <mat-radio-group
          (change)="parameterTypeChanges()"
          fxLayoutGap="20px"
          formControlName="parameter_type_id"
          color="primary">
          <mat-radio-button [value]="1">Campos do sistema</mat-radio-button>
          <mat-radio-button [value]="2">Valor fixo</mat-radio-button>
        </mat-radio-group>
      </div>
      <div
        [style.padding-top.em]="1.34375"
        fxFlex>
        <mat-form-field
          *ngIf="control.get('parameter_type_id').value == 2"
          appearance="fill"
          fxFlex>
          <mat-label>Valor fixo</mat-label>
          <input
            [type]="control.get('field_type_id').value === 5 ? 'number' : 'text'"
            matInput
            #input
            formControlName="fixed_value">
          <mat-error *ngIf="control.get('fixed_value').hasError('valueFixedValue') && control.get('is_required').value === 1">
            Campo obrigatório
          </mat-error>
        </mat-form-field>
        <mat-form-field
          *ngIf="control.get('parameter_type_id').value == 1"
          appearance="fill"
          fxFlex>
          <mat-label>Campo sistema</mat-label>
          <input
            type="text"
            matInput
            formControlName="field_id"
            [matAutocomplete]="auto">
          <mat-autocomplete
            #auto="matAutocomplete"
            autoActiveFirstOption="true"
            [displayWith]="displayFn">
            <mat-option
              *ngFor="let option of filteredSystemFieldOptions[i] | async"
              [value]="option"
              [matTooltip]="option.label"
              matTooltipPosition="below"
              matTooltipClass="ps-tooltip-content"
              [matTooltipShowDelay]="200"
            >
              {{option.label}}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="control.get('field_id').hasError('valueFieldId') && control.get('is_required').value === 1">
            Campo obrigatório
          </mat-error>
          <mat-error
            *ngIf="control.get('field_id').hasError('match') && !control.get('field_id').hasError('valueFieldId')">
            Selecione o campo
          </mat-error>
        </mat-form-field>
        <div *ngIf="control.get('parameter_type_id').value != null && control.get('is_required').value == 0" class="clear-button" fxflex="20">
          <button mat-button (click)="clear(i)" >
            Limpar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
